 <template>
  <jet-form-section @submitted="updateProfileInformation">
    <template #title>Profile Information</template>

    <template #description>
      Update your account's profile information and email address.
    </template>

    <template #form>
      <jet-action-message :on="form.recentlySuccessful">Saved.</jet-action-message>

        <!-- Company Name -->
        <div class="form-group" v-if="this.$page.props.auth.user.role == 'mtd'">
          <jet-label class="mb-1" for="company_name" value="Company Name" />
          <jet-input id="company_name" type="text" v-model="form.company_name" :class="{ 'is-invalid': form.errors.company_name }" autocomplete="company_name" />
          <jet-input-error :message="form.errors.company_name" />
        </div>

      <!-- Logo -->
      <div class="form-group" v-if="this.$page.props.auth.user.role == 'mtd'">
        <!-- Profile Photo File Input -->
        <input type="file" hidden
               ref="photo"
               @change="updatePhotoPreview">

        <jet-label class="mb-1" for="photo" value="Company Logo" />

        <!-- Current Profile Photo -->
        <div class="mt-2" v-show="! photoPreview && user.logo_url">
          <img :src="user.logo_url" alt="Current Logo">
        </div>

        <!-- New Profile Photo Preview -->
        <div class="mt-2" v-show="photoPreview">
          <img :src="photoPreview" width="100">
        </div>

        <div>
          <jet-button icon="fas fa-file-image" class="mt-2 mr-2 btn-short" type="button" @click.prevent="selectNewPhoto">
            Select Logo Image
          </jet-button>

          <jet-button type="button" class="mt-2 btn-short" @click.prevent="deletePhoto" v-if="user.logo_path">
            Remove Logo
          </jet-button>
        </div>
        <jet-input-error :message="form.errors.photo" class="mt-2" />
      </div>

      <!-- Name -->
      <div class="form-group form-row">
        <div class="col-12 col-lg-6 mb-3 mb-lg-0">
          <jet-label class="mb-1" for="first_name" value="First Name" />
          <jet-input id="first_name" type="text" v-model="form.first_name" :class="{ 'is-invalid': form.errors.first_name }" autocomplete="first_name" />
          <jet-input-error :message="form.errors.first_name" />
        </div>
      
        <div class="col-12 col-lg-6">
          <jet-label class="mb-1" for="last_name" value="Last Name" />
          <jet-input id="last_name" type="text" v-model="form.last_name" :class="{ 'is-invalid': form.errors.last_name }" autocomplete="last_name" />
          <jet-input-error :message="form.errors.last_name" />
        </div>
      </div>

      <!-- Email -->
      <div class="form-group">
        <jet-label class="mb-1" for="email" value="Email" />
        <jet-input id="email" type="email" v-model="form.email"
                    :class="{ 'is-invalid': form.errors.email }" />
        <jet-input-error :message="form.errors.email" />
      </div>
    </template>

    <template #actions>
      <jet-button :class="{ 'text-white-50': form.processing }" btnStyle="dark" type="submit" icon="fas fa-save" :disabled="form.processing">
        Save
      </jet-button>
    </template>
  </jet-form-section>
</template>

<script>
import JetButton from '@/Jetstream/Button'
import JetFormSection from '@/Jetstream/FormSection'
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'
import JetActionMessage from '@/Jetstream/ActionMessage'

export default {
  components: {
    JetActionMessage,
    JetButton,
    JetFormSection,
    JetInput,
    JetInputError,
    JetLabel,
  },

  props: ['user'],

  data() {
    return {
      form: this.$inertia.form({
        _method: 'PUT',
        company_name: this.user.company_name,
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        photo: null,
      }),

      photoPreview: null,
    }
  },

  methods: {
    updateProfileInformation() {
      if (this.$refs.photo) {
        this.form.photo = this.$refs.photo.files[0]
      }

      let action = (this.$page.props.auth.user.role == 'mtd') ? 'mtd.user.updateprofile' : 'tu.user.updateprofile';

      this.form.post(route(action), {
        errorBag: 'updateProfileInformation',
        preserveScroll: true
      });
    },

    selectNewPhoto() {
      this.$refs.photo.click();
    },

    updatePhotoPreview() {
      const reader = new FileReader();

      reader.onload = (e) => {
        this.photoPreview = e.target.result;
      };

      reader.readAsDataURL(this.$refs.photo.files[0]);
    },

    deletePhoto() {
      this.$inertia.delete(route('mtd.deletelogo'), {
        preserveScroll: true,
        onSuccess: () => (this.photoPreview = null),
      });
    },
  },
}
</script>
